import React from 'react'

import Sizes from '../Input.sizes'
import { TextArea } from './Input.textarea.style'

export interface InputTextAreaProps {
    onChange?: (e: React.FormEvent) => void
    size?: Sizes
    value?: string
    noresize?: boolean
    borderColor?: string | boolean
}

const InputTextArea = React.forwardRef(
    (props: InputTextAreaProps, ref) => {
        const {
            borderColor = undefined,
            noresize = false,
            onChange = () => undefined,
            size = Sizes.MD,
            value = '',
            ...rest
        } = props

        return (
            <TextArea
                ref={ref as React.RefObject<HTMLTextAreaElement>}
                onChange={onChange}
                size={size}
                value={value || ''}
                noresize={noresize}
                borderColor={borderColor}
                {...rest}
            />
        )
    },
)

export default InputTextArea
